import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import UserCreate from "./UserCreate";
import StyledModal from '../../../../shared/layout/modals/StyledModal';
import ModalHeader from '../../../../shared/layout/modals/ModalHeader';
import ModalTitle from '../../../../shared/layout/modals/ModalTitle';
import ModalBody from '../../../../shared/layout/modals/ModalBody';
import CloseButton from '../../../../shared/layout/modals/CloseButton';

const UserModal = ({ show, onClose, onUserAdded, mode = 'create', customerId = null }) => {
    const { t } = useTranslation();

    if (!show) return null;

    const modalTitle = mode === 'edit'
        ? t('Users.UsersList.editModalTitle')
        : t('Users.UsersList.modalTitle');

    return (
        <ModalWrapper>
            <Backdrop onClick={onClose} />
            <StyledModal>
                <ModalHeader>
                    <ModalTitle>{modalTitle}</ModalTitle>
                    <CloseButton onClick={onClose}>&times;</CloseButton>
                </ModalHeader>
                <ModalBody>
                    <UserCreate
                        onClose={onClose}
                        onUserAdded={onUserAdded}
                        mode={mode}
                        customerId={customerId}
                    />
                </ModalBody>
            </StyledModal>
        </ModalWrapper>
    );
};


export default UserModal;

// Styled Components
const ModalWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1050;
`;

const Backdrop = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(4px);
    z-index: 1040;
`;
